import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './components/pages/appComponent/App';
import reportWebVitals from './reportWebVitals';
import { HashRouter} from "react-router-dom";

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HashRouter>
          <App />
    </HashRouter>
  </React.StrictMode>
);

// Web vitals reporting remains unchanged
reportWebVitals();